
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M9.29 32.5h21.42v5.75H9.29zM30.71 16.79a31.6 31.6 0 00-21.42 0v-4.45a31.6 31.6 0 0121.42 0zM9.29 25.6a31.45 31.45 0 0121.42 0M16.43 32.15V14.98M23.57 14.98v17.17M9.29 32.15V16.89M30.71 16.89v15.26M19.98 10.54V1.75M30.47 32.24l8.38 2.23M9.53 32.24l-8.38 2.23M30.97 12.42H39v4.31h-8.03"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M39 16.73v21.52h-8.92M9.03 12.42H1v4.31h8.03M1 16.73v21.52h8.92M24.26 2.5h-5.28"}})])
          )
        }
      }
    